import Default from './Default';
import DateJoined from './DateJoined';

export const config = {
  default: Default,
  date_joined: DateJoined
};
